import React from 'react';
import { Layout } from '../components/layout/Layout';
import { MaterialesTable } from '../components/materiales/MaterialesTable';
import { Typography, Box, CircularProgress } from '@mui/material';
import { useObras } from '../context/ObrasContext';

export const Materiales = () => {
  const { obras, obraSeleccionada, loading } = useObras();

  if (loading) {
    return (
      <Layout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: 'grey.900',
            mb: 1
          }}
        >
          Materiales
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'grey.600',
            mb: 3
          }}
        >
          Gestiona los materiales de todas las obras
        </Typography>
      </Box>
      <MaterialesTable obras={obras} obraSeleccionada={obraSeleccionada} />
    </Layout>
  );
};

export default Materiales;